import { render, staticRenderFns } from "./ser_conference.vue?vue&type=template&id=310ded48&scoped=true&"
import script from "./ser_conference.vue?vue&type=script&lang=js&"
export * from "./ser_conference.vue?vue&type=script&lang=js&"
import style0 from "./ser_conference.vue?vue&type=style&index=0&id=310ded48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310ded48",
  null
  
)

export default component.exports